import { useState, useEffect } from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
// import { useToast } from '@/components/ui/use-toast'

// Dočasné jednoduché toast řešení
const useToast = () => ({
  toast: ({ title, description, variant: _variant }: { title: string; description?: string; variant?: string }) => {
    alert(`${title}${description ? '\n' + description : ''}`)
  }
})
import { Lock, Settings, BarChart3, Eye, EyeOff, WifiOff } from 'lucide-react'
import { adminClient } from '@/api/adminClient'
import ConfigurationTab from './components/ConfigurationTab'
import MonitoringTab from './components/MonitoringTab'
import OfflineQueueTab from './components/OfflineQueueTab'

export default function AdminPage() {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [password, setPassword] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const { toast } = useToast()

  useEffect(() => {
    // Zkontrolujeme, jestli už jsme přihlášeni
    const savedPassword = sessionStorage.getItem('adminPassword')
    if (savedPassword) {
      adminClient.setPassword(savedPassword)
      setIsAuthenticated(true)
    }
  }, [])

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsLoading(true)

    try {
      adminClient.setPassword(password)
      
      // Testujeme přihlášení voláním config endpointu
      await adminClient.getConfig()
      
      // Pokud nehodí error, jsme přihlášeni
      sessionStorage.setItem('adminPassword', password)
      setIsAuthenticated(true)
      
      toast({
        title: 'Přihlášení úspěšné',
        description: 'Vítejte v admin panelu',
      })
      
    } catch (error) {
      toast({
        title: 'Chyba při přihlašování',
        description: error instanceof Error ? error.message : 'Neplatné heslo',
        variant: 'destructive',
      })
    } finally {
      setIsLoading(false)
    }
  }

  const handleLogout = () => {
    setIsAuthenticated(false)
    setPassword('')
    sessionStorage.removeItem('adminPassword')
    toast({
      title: 'Odhlášení',
      description: 'Byli jste úspěšně odhlášeni',
    })
  }

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <Card className="w-full max-w-md">
          <CardHeader className="text-center">
            <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-blue-100">
              <Lock className="h-6 w-6 text-blue-600" />
            </div>
            <CardTitle>Admin Panel</CardTitle>
            <CardDescription>
              Přihlaste se pro přístup k administraci Lead Kiosk systému
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleLogin} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="password">Heslo</Label>
                <div className="relative">
                  <Input
                    id="password"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Zadejte admin heslo"
                    required
                    disabled={isLoading}
                  />
                  <Button
                    type="button"
                    variant="ghost"
                    size="sm"
                    className="absolute right-0 top-0 h-full px-3 py-2 hover:bg-transparent"
                    onClick={() => setShowPassword(!showPassword)}
                    disabled={isLoading}
                  >
                    {showPassword ? (
                      <EyeOff className="h-4 w-4" />
                    ) : (
                      <Eye className="h-4 w-4" />
                    )}
                  </Button>
                </div>
              </div>
              <Button type="submit" className="w-full" disabled={isLoading}>
                {isLoading ? 'Přihlašování...' : 'Přihlásit se'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <div className="max-w-6xl mx-auto">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Admin Panel</h1>
            <p className="text-gray-600">Správa Lead Kiosk systému</p>
          </div>
          <Button onClick={handleLogout} variant="outline">
            Odhlásit se
          </Button>
        </div>

        <Tabs defaultValue="config" className="space-y-6">
          <TabsList className="grid w-full grid-cols-3">
            <TabsTrigger value="config" className="flex items-center gap-2">
              <Settings className="h-4 w-4" />
              Konfigurace
            </TabsTrigger>
            <TabsTrigger value="monitoring" className="flex items-center gap-2">
              <BarChart3 className="h-4 w-4" />
              Monitoring
            </TabsTrigger>
            <TabsTrigger value="offline-queue" className="flex items-center gap-2">
              <WifiOff className="h-4 w-4" />
              Offline Fronta
            </TabsTrigger>
          </TabsList>

          <TabsContent value="config">
            <ConfigurationTab />
          </TabsContent>

          <TabsContent value="monitoring">
            <MonitoringTab />
          </TabsContent>

          <TabsContent value="offline-queue">
            <OfflineQueueTab />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  )
} 